import React from 'react';

import {
  CheckIconWrap,
  CloseButton,
  Container,
  Message,
  TextWrap,
  Title,
} from './styles';

export type ToastProps = {
  title: string;
  message: string;
  layout?: 'inline' | 'stacked';
  onClose?: () => void;
};

const SuccessCheckIcon = (): JSX.Element => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 9L7 12.5L14.5 5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseIcon = (): JSX.Element => (
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3L11 11M11 3L3 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const Toast = ({
  title,
  message,
  layout = 'inline',
  onClose,
}: ToastProps): JSX.Element => (
  <Container role="status" $stacked={layout === 'stacked'}>
    <CheckIconWrap aria-hidden="true">
      <SuccessCheckIcon />
    </CheckIconWrap>
    <TextWrap $stacked={layout === 'stacked'}>
      {layout === 'stacked' ? (
        <>
          <Title>{title}</Title>
          <Message>{message}</Message>
        </>
      ) : (
        <>
          <Title>{title}</Title>{' '}
          <Message>{message}</Message>
        </>
      )}
    </TextWrap>
    {onClose && (
      <CloseButton type="button" aria-label="Fechar notificação" onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    )}
  </Container>
);

export default Toast;
